export default "__VITE_ASSET__BpJojM$y__"